<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-card-title>
      OT Bill List
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-col cols="12" sm="4">
        <v-row justify="space-around">
          <v-badge color="grey" :content="desserts.length" overlap>
            <v-chip dark> Active</v-chip>
          </v-badge>
          <span v-for="item in summary" :key="item.id">
            <v-badge :color="getColor(item.opp_status)" :content="item.total" overlap>
              <v-chip :color="getColor(item.opp_status)" text-color="white">
                {{ item.opp_status.toUpperCase() }}</v-chip
              >
            </v-badge>
          </span>
        </v-row>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="date"
                label="Select Date"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                dense
                outlined
                hide-details
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="date"
              @input="menu2 = false"
              @click:date="dateSelect"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <template>
          <v-text-field
              v-model="search"
              prepend-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
              dense
              outlined
          ></v-text-field>
        </template>
      </v-col>

      <v-col cols="12" sm="6" md="1">
        <template>
          <v-row align="center" justify="space-around">
            <v-btn depressed color="primary" append-icon="mdi-printer" @click="printList"
            >Print
            </v-btn>
          </v-row>
        </template>
      </v-col>
    </v-card-title>
    <v-card>
      <v-data-table
          :headers="headers"
          :items="itemsWithSno"
          class="elevation-1"
          :search="search"
          dense
          :loading="loadingstatus"
          loading-text="Loading... Please wait"
      >
        <template v-slot:item.operation_subhead="{ item }">
          <span v-if="item.operation">{{ item.operation.name }}</span>
          <v-chip v-if="item.operation_subhead" class="ma-2" color="error" outlined small>
            {{ item.operation_subhead }}
          </v-chip>
        </template>
        <template v-slot:item.opp_status="{ item }">
          <v-chip :color="getColor(item.opp_status)" dark label outlined small>
            {{ item.opp_status.toUpperCase() }}
          </v-chip>
        </template>
        <template v-slot:item.paid_amount="{ item }">
          <div class="d-flex justify-center font-weight-black">
            {{ b_number_format(item.paid_amount) }}
          </div>
        </template>
        <template v-slot:item.hospital_amount="{ item }">
          <div class="d-flex justify-center font-weight-black">
            {{ b_number_format(item.hospital_amount) }}
          </div>
        </template>
        <template v-slot:item.doctor_amount="{ item }">
          <div class="d-flex justify-center font-weight-black">
            {{ b_number_format(item.doctor_amount) }}
          </div>
        </template>
        <template v-slot:item.actions="{ item }">

          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="ot_details(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  color="orange"
                  label
                  outlined
                  small
              ><v-icon> mdi-chevron-double-right </v-icon>
              </v-chip>
            </template>
            <span>OT Registration Details</span>
          </v-tooltip>
          <!-- <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                @click="recieve_money(item)"
                dark
                v-bind="attrs"
                v-on="on"
                class="ma-2"
                open
                color="primary"
                label
                outlined
                small
              >
                <v-icon> mdi-cash </v-icon>
              </v-chip>
            </template>
            <span>Receive Money</span>
          </v-tooltip> -->
          <v-tooltip top>
            <template v-if="item.opp_status != 'cancel'" v-slot:activator="{ on, attrs }">
              <v-chip
                  @click="ot_refund(item)"
                  dark
                  v-bind="attrs"
                  v-on="on"
                  class="ma-2"
                  open
                  color="primary"
                  label
                  outlined
                  small
              ><v-icon> mdi-undo-variant </v-icon>
              </v-chip>
            </template>
            <span>Refund to Patient</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../../js/setup";
export default {
  data() {
    return {
      search: "",
      date: new Date().toISOString().substr(0, 10),
      nowDate: new Date().toISOString().substr(0, 10),
      menu2: false,
      loadingstatus: true,
      summary: {},
      headers: [
        {
          text: "Serial #",
          value: "sno",
        },
        {
          text: "OT ID",
          value: "registration_no",
        },
        {
          text: "ID",
          value: "patient_id",
        },
        { text: "Patient Name", value: "patient.patient_name" },
        { text: "Doctor", value: "doctor.dr_name" },
        { text: "Operation Name", value: "operation_subhead" },
        // { text: "OT Date", value: "opp_date", Key: "Date" },
        { text: "Paid Amount", value: "paid_amount" },
        { text: "Hospital Amount", value: "hospital_amount" },
        { text: "Doctor Amount", value: "doctor_amount" },
        { text: "Status", value: "opp_status" },
        { text: "Action", value: "actions", sortable: false },
      ],

      desserts: [],
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Operations",
          disabled: true,
          href: "patients",
        },
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,
    };
  },
  // Fetches posts when the component is created.
  created() {
    this.initialize(this.date);
    // console.log(this.$store.getters.getUserName);
    // console.log(atshq.defaults.headers.common.api_URL);
  },
  computed: {
    itemsWithSno() {
      return this.desserts.map((d, index) => ({ ...d, sno: index + 1 }));
    },
  },
  methods: {
    initialize(date) {
      atshq
          .get("ot-bill-list?date=" + date)
          .then((response) => {
            this.desserts = response.data.data;
            this.loadingstatus = false;
          })
          .catch((e) => {
            this.errors.push(e);
          });
      atshq
          .get("ot-bill-summary?date=" + date)
          .then((response) => {
            this.summary = response.data.data;
            this.loadingstatus = false;
          })
          .catch((e) => {
            this.errors.push(e);
          });
    },
    b_number_format(n) {
      // return n.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
      return n != null ? n.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",") : n;
    },
    getColor(status) {
      if (status == "open") return "orange";
      else if (status == "close") return "green";
      else if (status == "cancel") return "red";
    },
    printList() {
      window.open(this.returnUrl + "/printdoc/otbill/" + this.date);
    },
    dateSelect(date) {
      this.loadingstatus = true;
      this.initialize(date);
    },
    ot_details(item) {
      window.location.href = "/ot-registration/" + item.registration_no;
    },
    ot_refund(item) {
      window.location.href = "/otbill-refund/" + item.registration_no;
    },
    recieve_money(item) {
      window.location.href = "/otbill-received/" + item.registration_no;
    },

  },
};
</script>
